import React, { useRef } from 'react'
import Uploader from '../uploader';
import { extractFileId } from '../../../../../../utils/data';
import InputWithLabel from '../../../../../../components/inputWithLabel';
import { removeImage, uploadImageApi } from '../../../../../../api/apis/assesments';
import { getAssessmentData } from '../../../../../../functions/localStorage';
import { parseIfStringify } from '../../../../../../functions/common';

const TextUpload = ({ data, handleAnswer, answers, setUploadLoading, uploadLoading, currentIndex }) => {

  const splittesAnswer = answers?.[data?.refCode]?.split(" + ");
  const selectedOption = splittesAnswer?.[0] ?? "";
  const inputRef = useRef();
  const { locationId, assessmentId } = getAssessmentData() ?? {};
  const images = parseIfStringify(
      answers?.[data?.refCode]?.split(" + ")?.[1]?.replace("", "") ?? []
    );
  const handleDelete = (item) => {
    const driveId = extractFileId(item?.viewLink);
    const updatedImages = images?.filter(v => v?.viewLink !== item?.viewLink)
    handleAnswer(`${selectedOption} + ${JSON.stringify(updatedImages)}`);
    if (driveId) removeImage(driveId);
  };

  const handleFileUpload = async (file) => {
    if (file) {
      setUploadLoading(true);
      const imageData = await uploadImageApi({
        file: file,
        ref: data?.refCode,
      }, locationId, assessmentId);
      setUploadLoading(false);
      const fileData = {
        fileName: imageData?.data?.fileName,
        viewLink: imageData?.data?.viewLink,
      };
      const updatedImages = [...images, fileData];
      const formattedAnswer = `${selectedOption} + ${JSON.stringify(updatedImages)}`;
      handleAnswer(formattedAnswer);
      inputRef.current.value = "";
    }
  };

  const handleChangeInput = (value) => {
    if (data?.supportingDoc) {
      handleAnswer(`${value} + ${JSON.stringify(images)}`)
    } else {
      handleAnswer(`${value}`)
    }
  }
  return (
    <>
      <div className="text__upload__main">
        {data?.responseType === "NUM" ?
          <div className="yes__text__comment">
            <p>{data?.prompt}</p>
            <InputWithLabel
              value={!isNaN(selectedOption) && Number(selectedOption) !== 0 ? Number(selectedOption) : null}
              type={"number"}
              onChange={(e) => handleChangeInput(e.target.value)}
            />
          </div>
          : <div className="yes__text__comment">
            <p>{data?.prompt}</p>
            <textarea
              rows="6"
              value={selectedOption || ""}
              onChange={(e) => handleChangeInput(e.target.value)}
            ></textarea>
          </div>}
        {data?.supportingDoc && (
          <Uploader
            inputRef={inputRef}
            handleFileUpload={handleFileUpload}
            handleUpload={handleFileUpload}
            handleDelete={handleDelete}
            uploadLoading={uploadLoading}
            data={data}
            images={images}
            currentIndex={currentIndex}
          />
        )}
      </div>
    </>
  )
}

export default TextUpload